import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeTranslateIn = keyframes`
  from {
      transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Relative = styled.div`
  &.animate {
    opacity: 0;
    animation: 500ms ${fadeTranslateIn} 400ms ease-out forwards;
  }
`;

type Props = { revealed?: boolean };
export const RewardBaseAnimation = ({
  children,
  revealed: revealedProp,
}: PropsWithChildren<Props>) => {
  // HACK: Prevent the animation to trigger from a remount
  const [revealedAtFirstRender] = useState(revealedProp);
  const [animate, setAnimate] = useState(false);
  if (!revealedAtFirstRender && revealedProp && !animate) {
    setAnimate(true);
  }

  return <Relative className={classNames({ animate })}>{children}</Relative>;
};
